// Juntadas de PF (Diligência/Reconsideração/Recurso): o legado tem um modelo de
// requerimento por categoria OAB (Advogado(a)/Estagiário(a)) e nenhum pra quem
// ainda não é inscrito — mas essa pessoa também precisa das Juntadas, pra
// responder a um problema no próprio pedido de inscrição. Por isso ela diz no
// formulário a qual inscrição a juntada se refere; os valores das opções são os
// mesmos de `tipoCategoria`, então o `map` do protocoloConfig serve pros dois.

import { identificacaoSociedadeSection } from './sociedadeSections';

export const CAMPO_INSCRICAO_REFERENCIA = 'inscricaoReferencia';

// Some pra PF já inscrita (adaptarConfigAoPerfil), que usa a própria categoria.
export const inscricaoReferenciaSection = {
  title: 'Pedido de Inscrição',
  fields: [
    {
      type: 'radio',
      name: CAMPO_INSCRICAO_REFERENCIA,
      label: 'A qual pedido de inscrição esta juntada se refere?',
      required: true,
      apenasNaoInscrito: true,
      options: [
        { value: 'ADVOGADO(A)', label: 'Inscrição de Advogado(a) (Originária, Suplementar ou por Transferência)' },
        { value: 'ESTAGIÁRIO(A)', label: 'Inscrição de Estagiário(a)' }
      ]
    }
  ]
};

/**
 * Condicional de protocoloConfig pela categoria OAB de quem está logado, com
 * a resposta de `inscricaoReferenciaSection` como alternativa pra quem não tem
 * categoria (PF não inscrita).
 */
export const porCategoriaOuInscricaoReferencia = (map) => ({
  source: 'oabCategoria',
  fieldSemCategoria: CAMPO_INSCRICAO_REFERENCIA,
  map
});

// Juntadas de Sociedade (Diligência/Reconsideração/Recurso): quem protocola é a
// própria sociedade (PJ logada) ou um(a) Advogado(a) (PF) em nome dela.
// - PJ: `versaoPJ` — Nome da Sociedade e CNPJ, preenchidos com o login e travados
//   (adaptarConfigAoPerfil);
// - PF: Nome completo e CPF dela (vêm do cadastro e ficam travados, como em todo
//   pedido de PF) e se a sociedade já tem pessoa jurídica criada na OAB — se
//   sim, o nome dela e o CNPJ, opcional porque a PJ pode ainda não ter CNPJ.
export const CAMPO_POSSUI_PJ_OAB = 'possuiPessoaJuridicaOab';

export const juntadaSociedadeStep = () => ({
  id: 'dados_requerente',
  title: 'Dados do Requerente',
  sections: [
    {
      title: 'Identificação do Requerente',
      fields: [
        { type: 'text', name: 'nomeCompleto', label: 'Nome completo', required: true, placeholder: 'Digite seu nome completo' },
        { type: 'cpf', name: 'cpf', label: 'CPF', required: true }
      ]
    },
    {
      title: 'Sociedade',
      fields: [
        {
          type: 'radio',
          name: CAMPO_POSSUI_PJ_OAB,
          label: 'Este pedido é para uma sociedade que já tem pessoa jurídica (razão social) criada na OAB?',
          required: true,
          options: [{ value: 'SIM', label: 'Sim' }, { value: 'NAO', label: 'Não' }]
        },
        {
          type: 'text',
          name: 'nomeSociedade',
          label: 'Nome da Sociedade',
          required: true,
          placeholder: 'Razão social da sociedade',
          showWhen: { field: CAMPO_POSSUI_PJ_OAB, value: 'SIM' }
        },
        {
          type: 'cnpj',
          name: 'cnpj',
          label: 'CNPJ (se a sociedade já tiver)',
          required: false,
          showWhen: { field: CAMPO_POSSUI_PJ_OAB, value: 'SIM' }
        }
      ]
    }
  ],
  versaoPJ: {
    id: 'dados_sociedade',
    title: 'Dados da Sociedade',
    sections: [identificacaoSociedadeSection()]
  }
});
